export default __webpack_public_path__ + "static/media/nft5.ef0429df.png";